import {NavigationEntityState} from '~ui/store/slices/navigation-tree';

export const getSlugsToUpdate = (entities: Record<string, NavigationEntityState>) => {
    const slugsToUpdateMap: Record<string, string> = {};

    for (const key in entities) {
        const entity = entities[key];

        if (!entity || !entity.virtualSlug) continue;

        slugsToUpdateMap[entity.slug] = entity.virtualSlug;
    }

    return slugsToUpdateMap;
};
